<template>
  <div class="search-list">
    <template v-if="combineSearchResult.length && !isSearchResultNullForTaiwantrade">
      <div class="search-subtitle">
        {{ $t('searchResult') }}
      </div>
      <div class="search-container">
        <div class="search-result-box">
          <template v-for="item in combineSearchResult">
            <div
              :key="item.markerId + (item.objectId ? '-' + item.objectId : '')"
            >
              <div
                v-if="selectedCategory === CATEGORY_OPTIONS[0]"
                class="item-kind"
              >
                {{ $t(item.kind) }}
              </div>
              <div class="search-result-item">
                <div class="item-image">
                  <template v-if="item.kind === 'product'">
                    <img
                      v-if="item.type === 'gallery' "
                      :src="item.photo"
                    >
                    <img
                      v-else-if="item.type === 'videoplay' && item.videoplayAttribute.type === 'embed'"
                      :src="getEmbedVideoThumbnail(item.videoplayAttribute)"
                    >
                    <img
                      v-else
                      :src="getMarkerProfile(item)"
                    >
                  </template>
                  <template v-else-if="item.kind === 'company'">
                    <img :src="item.logoUrl">
                  </template>
                  <template v-else-if="item.kind === 'livetour'">
                    <img :src="item.thumbnail">
                  </template>
                </div>
                <div class="item-info">
                  <div class="full-width">
                    <h3 class="item-name">
                      {{ item.nameMulti[lang] || item.name }}
                    </h3>
                    <div class="full-width limit-line item-description">
                      {{ item.descriptionMulti[lang] || item.description }}
                    </div>
                  </div>
                  <div class="item-tags">
                    <i-tag-list :tags="getCategory(item)" />
                  </div>
                </div>
                <div class="item-aciton-box">
                  <i-favorite
                    v-if="isFavoritesAvailable(item)"
                    :category="getItemCategory(item.kind)"
                    :item="item.raw"
                  >
                    <template #default="{ title, onClick }">
                      <button @click="onClick">
                        {{ title }}
                      </button>
                    </template>
                  </i-favorite>
                  <span v-else />
                  <template v-if="item.kind === 'product'">
                    <button
                      style="margin-top: 1rem;"
                      @click="$emit('gotoTarget', item)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                  <template v-else-if="item.kind === 'company'">
                    <button
                      style="margin-top: 1rem;"
                      @click="popupCompanyModal(item)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                  <template v-else-if="item.kind === 'livetour'">
                    <button
                      style="margin-top: 1rem;"
                      @click="$emit('gotoTarget', { buildingId: item.objectId, panoramaId: item.panoramas[0].objectId }, false)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <template v-if="combineRelatedResult.length">
      <div class="search-subtitle">
        {{ $t('relatedResult') }}
      </div>
      <div class="search-container">
        <div class="search-result-box">
          <template v-for="item in combineRelatedResult">
            <div
              :key="item.markerId + (item.objectId ? '-' + item.objectId : '')"
            >
              <div
                v-if="selectedCategory === CATEGORY_OPTIONS[0]"
                class="item-kind"
              >
                {{ $t(item.kind) }}
              </div>
              <div class="search-result-item">
                <div class="item-image">
                  <template v-if="item.kind === 'product'">
                    <img
                      v-if="item.type !== 'gallery'"
                      :src="getMarkerProfile(item)"
                    >
                    <img
                      v-if="item.type === 'gallery' "
                      :src="item.photo"
                    >
                  </template>
                  <template v-else-if="item.kind === 'company'">
                    <img :src="item.logoUrl">
                  </template>
                  <template v-else-if="item.kind === 'livetour'">
                    <img :src="item.thumbnail">
                  </template>
                </div>
                <div class="item-info">
                  <div class="full-width">
                    <h3 class="item-name">
                      {{ item.nameMulti[lang] || item.name }}
                    </h3>
                    <div class="full-width limit-line item-description">
                      {{ item.descriptionMulti[lang] || item.description }}
                    </div>
                  </div>
                  <div class="item-tags">
                    <i-tag-list :tags="getCategory(item)" />
                  </div>
                </div>
                <div class="item-aciton-box">
                  <i-favorite
                    v-if="isFavoritesAvailable(item)"
                    :category="getItemCategory(item.kind)"
                    :item="item.raw"
                  >
                    <template #default="{ title, onClick }">
                      <button @click="onClick">
                        {{ title }}
                      </button>
                    </template>
                  </i-favorite>
                  <template v-if="item.kind === 'product'">
                    <button
                      style="margin-top: 1rem;"
                      @click="$emit('gotoTarget', item)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                  <template
                    v-else-if="item.kind === 'company'"
                  >
                    <button
                      style="margin-top: 1rem;"
                      @click="popupCompanyModal(item)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                  <template v-else-if="item.kind === 'livetour'">
                    <button
                      style="margin-top: 1rem;"
                      @click="gotoBuilding(item)"
                    >
                      {{ $t('cardMore') }}
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </template>
        </div>
      </div>
    </template>
    <div
      v-if="combineSearchResult.length === 0 && combineRelatedResult.length === 0"
      class="no-result-box"
    >
      <p>{{ $t('noSearchResult') }}</p>
    </div>
    <i-modal
      ref="company-modal"
      bgcolor="rgba(0,0,0,0.7)"
      closeable
      @closed="currentCompany = {}"
    >
      <div class="company-info">
        <div class="company-header">
          <div class="company-detail">
            <div class="company-action">
              <h3>{{ currentCompany.name }}</h3>
              <i-favorite
                category="user"
                :item="currentCompany.raw"
              >
                <template #default="{ title, onClick }">
                  <button @click="onClick">
                    {{ title }}
                  </button>
                </template>
              </i-favorite>
            </div>
            <div class="desktop-tag-list">
              <i-tag-list
                :tags="getCategory(currentCompany)"
                @click="closeCompanyModal"
              />
            </div>
          </div>
          <div class="company-logo">
            <img :src="currentCompany.logoUrl">
          </div>
          <div class="mobile-tag-list">
            <i-tag-list
              :tags="getCategory(currentCompany)"
              @click="closeCompanyModal"
            />
          </div>
        </div>
        <div class="company-body">
          <p class="company-description">
            {{ currentCompany.description }}
          </p>
        </div>
        <div
          class="company-buildings"
          :class="[currentCompanyBuildings.length >= 3 ? 'company-buildings-more' : 'company-buildings-less']"
        >
          <template v-for="building in currentCompanyBuildings">
            <div
              :key="'a' + building.objectId"
              class="building"
            >
              <div class="building-img">
                <img
                  :src="building.thumbnail"
                  :alt="building.name"
                >
              </div>
              <h3 class="building-name">
                {{ building.name }}
              </h3>
              <div class="building-description">
                {{ building.description }}
              </div>
              <div class="building-action">
                <button @click="gotoBuilding(building)">
                  {{ $t('clickNavigate') }}
                </button>
              </div>
            </div>
          </template>
        </div>
      </div>
    </i-modal>
  </div>
</template>

<script>
import { CATEGORY_OPTIONS, YOUTUBE_URL_PATTERN } from '~js/constants'
import { mapState, mapGetters, mapActions } from 'vuex'
import { getMarkerProfile } from '~js/helpers'
import ITagList from '@/components/ITagList'
import IFavorite from '@/components/IFavorite'
import IModal from '@/components/IModal'
import { truncateString } from '@/utils/utils'
import videoImage from '@/plugins/krpano/img/markers/video.png'

export default {
  components: {
    ITagList,
    IFavorite,
    IModal
  },

  props: {
    isSearchResultNullForTaiwantrade: {
      type: Boolean,
      required: true
    }
  },

  data () {
    return {
      CATEGORY_OPTIONS,
      currentCompany: {},
      lang: this.$i18n.locale,
      videoImage
    }
  },

  computed: {
    ...mapState('favorites', {
      favoritesMarkerTypes: state => state.acceptedMarkerTypes
    }),

    ...mapGetters([
      'currentBuilding',
      'property',
      'combineSearchResult',
      'combineRelatedResult',
      'selectedCategory'
    ]),

    currentCompanyBuildings () {
      if (this.currentCompany.objectId && this.property.buildings) {
        return this.property.buildings.filter(building => building.Owner.objectId === this.currentCompany.objectId && !building.unavailable)
      }
      return []
    }
  },

  methods: {
    getMarkerProfile,
    truncateString,

    ...mapActions([
      'selectBuilding'
    ]),

    isFavoritesAvailable (item) {
      if (item.kind === 'company') {
        return true
      }
      return this.favoritesMarkerTypes.includes(item.type)
    },

    getItemCategory (kind) {
      const category = {
        product: 'marker',
        company: 'user'
      }
      return category[kind]
    },

    popupCompanyModal (company) {
      this.currentCompany = company
      this.$refs['company-modal'].show()
    },

    closeCompanyModal () {
      this.$refs['company-modal'].hide()
      this.currentCompany = {}
    },

    gotoBuilding (target) {
      const isSameBuilding = this.currentBuilding.objectId === target.buildingId
      if (!isSameBuilding) {
        this.selectBuilding({
          buildingId: target.objectId,
          index: 0
        })
      }
      this.closeCompanyModal()
      this.$emit('close')
    },

    getEmbedVideoThumbnail ({ embedUrl = '', platform = '' }) { // videoplayAttribute
      if (platform === 'youtube') {
        const videoId = embedUrl.match(YOUTUBE_URL_PATTERN) ? embedUrl.match(YOUTUBE_URL_PATTERN)[1] : ''
        return `https://img.youtube.com/vi/${videoId}/sddefault.jpg`
      }
      return videoImage
    },
    getCategory (target) {
      return target?.categoryMulti?.[this.lang] || target?.category
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~css/addon/main'
@import '~css/common/extends'

.search-list {
  width: 100%
  margin-top: 12px
  overflow: auto
}

.search-subtitle {
  margin: 10px 20px 10px
  font-size: 20px
}

.search-container {
  position: relative
  // height: calc(100% - 40px)
  max-width: 90%
  width: 1280px
  margin: 0 auto
  border-radius: 10px
  background-color: #fff
  color: $black
  -webkit-overflow-scrolling: touch

  @extend .scrollbar-narrow

  &::-webkit-scrollbar-thumb {
    visibility: hidden
  }

  &:hover {
    &::-webkit-scrollbar-thumb {
      visibility: visible
    }
  }
}

.search-result-item {
  display: flex
  // align-items: center
  border-bottom: 2px solid $black
  padding: 8px 0
  margin-bottom: 4px
}

.search-result-box {
  padding: 20px 5%
}

.item-kind {
  width: 100%
  color: #F37A20
}

.item-image {
  flex-shrink: 0
  position: relative
  width: 16.66%
  padding-top: 16.66%
  background-color: rgba(88,88,90,0.9)

  & > img {
    position: absolute
    top: 50%
    left: 50%
    max-width: 100%
    max-height: 100%
    transform: translate(-50%, -50%)
  }
}

.item-info {
  display: flex
  flex-direction: column
  justify-content: space-between
  flex-shrink: 1
  flex-grow: 1
  padding: 0 8px
  width: calc(100% - 17% - 60px)

  @media (min-width: $response-sm) {
    width: calc(100% - 17% - 120px)
  }

  .item-name {
    text-shadow: none
    color: $black
    font-size: 1.25rem
    margin-bottom: 4px

    @media (min-width: $response-sm) {
      margin-bottom: 12px
    }
  }
}

.item-aciton-box {
  flex-shrink: 0
  width: 60px
  display: flex
  flex-direction: column
  justify-content: space-between

  @media (min-width: $response-sm) {
    width: 120px
  }

  button {
    width: 100%
    background-color: $black
    color: $white
    font-size: 0.9rem
    border-radius: 10px
    padding: 4px 10px

    @media (min-width: $response-sm) {
      font-size: 1rem
    }
  }
}

.company-info {
  padding: 12px
  height: 600px
  max-height: 80vh
  max-width: 90vw
  width: 640px
  background-color: $white
  overflow-y: scroll
  border-radius: 10px

  @media (min-width: $response-sm) {
    padding: 20px
  }
}

.company-header {
  display: block

  @media (min-width: $response-sm) {
    display: flex
  }

  .company-logo {
    flex-shrink: 0
    position: relative
    width: 120px
    order: 1
    padding-top: 120px
    background-color: rgba(88,88,90,0.9)

    & > img {
      position: absolute
      top: 50%
      left: 0
      width: 100%
      transform: translateY(-50%)
    }
  }
}

.company-detail {
  display: flex
  flex-direction: column
  justify-content: space-between
  flex-grow: 1
  order: 2
  flex-shrink: 1
  padding-left: 8px

  .company-action {
    margin-bottom: 1rem
    display: flex
    align-items: center
    justify-content: space-between

    h3 {
      flex-shrink: 1
      text-shadow: none
      color: $black
      font-size: 1.25rem
      margin: 12px 0
    }

    button {
      flex-shrink: 0
      width: 100px
      background-color: $black
      color: $white
      font-size: 0.9rem
      border-radius: 10px
      padding: 4px 0

      @media (min-width: $response-sm) {
        font-size: 1rem
        width: 100px
      }
    }
  }
}

.company-body {
  padding: 16px
}

.company-description {
  text-shadow: none
  color: $black
}

.no-result-box {
  display: flex
  justify-content: center
  align-items: center
  max-width: 90%
  width: 1280px
  max-height : 50vh
  height : 400px
  margin: 0 auto
  padding: 0 12px
  border-radius: 10px
  background-color: #fff
  color: $black

  & > p {
    text-shadow: none
    color: $black
    font-size: 1.1rem
  }
}

.company-buildings {
  display: flex
  flex-wrap: wrap
  width: 100%

  &-more {
    justify-content: space-between
  }

  &-less {
    justify-content: flex-start

    @media (min-width: $response-sm) {
      & .building:nth-child(1) {
        margin-right: 1rem
      }
    }
  }

  .building {
    margin-top: 1rem
    width: 100%
    flex: 0 0 auto

    @media (min-width: $response-sm) {
      width: 30%
    }
  }

  .building-img {
    position: relative
    width: 100%
    padding-top: 61.25%

    & > img {
      position: absolute
      top: 50%
      left: 50%
      max-width: 100%
      max-height: 100%
      transform: translate(-50%, -50%)
    }
  }

  .building-name {
    text-shadow: none
    color: $black
    font-size: 0.9rem
    margin: 6px 0
  }

  .building-description {
    padding: 6px 0
    height: 32px
    width: 100%
    text-shadow: none
    color: $black
    overflow: hidden
    white-space: nowrap
    text-overflow: ellipsis
  }

  .building-action {
    display: flex
    justify-content: flex-end

    & > button {
      background-color: $black
      color: $white
      font-size: 0.8rem
      border-radius: 10px
      padding: 4px 0
      width: 120px

      @media (min-width: $response-sm) {
        font-size: 0.9rem
        width: 80px
      }
    }
  }
}

.mobile-tag-list {
  display: block
  margin: 1rem 0
  @media (min-width: $response-sm) {
    display: none
  }
}

.desktop-tag-list {
  display: none
  @media (min-width: $response-sm) {
    display: block
  }
}

.limit-line {
  overflow: hidden
  text-overflow: ellipsis
  display: block
  display: -webkit-box
  -webkit-line-clamp: 3
  -webkit-box-orient: vertical
}
</style>
